import { render, staticRenderFns } from "./TestPackageGroupEdit.vue?vue&type=template&id=b50b5552"
import script from "./TestPackageGroupEdit.vue?vue&type=script&lang=js"
export * from "./TestPackageGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports